import React from "react";
import {
    Box,
    Skeleton,
    Text,
} from "@chakra-ui/react";
import Chart from "react-apexcharts";

const CertificationOverviewChart = ({
    data = {},
    isLoading,
}) => {
    const categories = [
        "Training",
        "Awaiting",
        "Certified",
        "Expired",
        "Not Started",
        "Failed",
    ];

    const seriesData = [
        data.agents_in_training ?? 0,
        data.agents_awaiting_certification ?? 0,
        data.certified_agents ?? 0,
        data.expired_certifications ?? 0,
        data.not_started ?? 0,
        data.failed ?? 0,
    ];

    const options = {
        chart: {
            type: "bar",
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                columnWidth: "55%",
            },
        },
        dataLabels: {
            enabled: false,
        },
        xaxis: {
            categories,
        },
        yaxis: {
            min: 0,
            forceNiceScale: true,
        },
        grid: {
            strokeDashArray: 4,
        },
    };

    return (
        <Box
            bg="white"
            borderRadius="15px"
            p="24px"
            height="400px"
            width="100%"
            boxShadow="sm"
        >
            <Text
                color="#071D54"
                fontSize="lg"
                fontWeight="700"
                mb={4}
            >
                Agent Certification Overview
            </Text>

            {isLoading ? (
                <Skeleton
                    height="300px"
                    borderRadius="12px"
                />
            ) : (
                <Chart
                    options={options}
                    series={[
                        {
                            name: "Agents",
                            data: seriesData,
                        },
                    ]}
                    type="bar"
                    height={300}
                />
            )}
        </Box>
    );
};

export default CertificationOverviewChart;